// extracted by mini-css-extract-plugin
export default {"exerciseItemAvatar":"CustomizedAvatar_exerciseItemAvatar__3HUha"};